export const GET_SERVICES = 'GET_SERVICES'
export const GET_SERVICES_SUCCESS = 'GET_SERVICES_SUCCESS'
export const UPDATE_SERVICES_PAGINATION = 'UPDATE_SERVICES_PAGINATION'
export const CREATE_SERVICE = 'CREATE_SERVICE'
export const CREATE_SERVICE_SUCCESS = 'CREATE_SERVICE_SUCCESS'
export const UPDATE_SERVICE = 'UPDATE_SERVICE'
export const UPDATE_SERVICE_SUCCESS = 'UPDATE_SERVICE_SUCCESS'
export const GET_SERVICE = 'GET_SERVICE'
export const GET_SERVICE_SUCCESS = 'GET_SERVICE_SUCCESS'
export const DELETE_SERVICE = 'DELETE_SERVICE'
export const DELETE_SERVICE_SUCCESS = 'DELETE_SERVICE_SUCCESS'